import { configureStore } from '@reduxjs/toolkit';
import userReducer from './slice/user';
import documentSlice from './slice/document';
import { dropdownReducer, fileReducer } from './slice/storage';
import apiSlice from './slice/apiSlice';
import chatSlice from './slice/chatSlice';
import pdfViewslice from './slice/pdfViewslice';
import sourceSlice from './slice/sourceSlice';
import historySlice from './slice/api/historySlice';
import qaHistorySlice from './slice/qaHistorySlice';
import taskSlice from './slice/taskSlice';
import aiProfileReducer from './slice/aiProfileSlice';
import sqReducer from './slice/sqSlice';
import adminSlice from './slice/userDataSlice';
import usersAll from './slice/usersSlice';
import taskStatusReducer from './slice/taskStatusSlice';
import organizationsReducer from './slice/organizationsSlice';
import subscriptionReducer from './slice/subscriptionSlice';
import usageReducer from './slice/usageSlice';
import themeReducer from './slice/themeSlice';
import supportSettingsReducer from './slice/supportSettingsSlice';

export default configureStore({
  reducer: {
    user: userReducer,
    document: documentSlice,
    file: fileReducer,
    dropdown: dropdownReducer,
    api: apiSlice,
    chat: chatSlice,
    pdfView: pdfViewslice,
    source: sourceSlice,
    history: historySlice,
    qaHistory: qaHistorySlice,
    tasks: taskSlice,
    aiProfile: aiProfileReducer,
    sq: sqReducer,
    admin: adminSlice,
    all: usersAll,
    taskStatus: taskStatusReducer,
    organizations: organizationsReducer,
    subscriptions: subscriptionReducer,
    usage: usageReducer,
    theme: themeReducer,
    supportSettings: supportSettingsReducer
  },
})
